<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "WhMonitoring",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  